import { useState } from 'react';

export default function BetaFeedbackButton() {
  const [open, setOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const elements = form.elements as HTMLFormControlsCollection;
    Array.from(elements).forEach((el) => {
      const input = el as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (input.name) {
        data.append(input.name, input.value);
      }
    });
    setSubmitting(true);
    try {
      await fetch('https://readdy.ai/api/form/d6ugjl6dp0k8rarn7kq0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* 浮動按鈕 */}
      <button
        type="button"
        onClick={() => { setOpen(true); setSubmitted(false); }}
        className="fixed bottom-6 left-4 z-40 flex items-center gap-2 px-4 py-2.5 text-white text-xs font-bold rounded-full cursor-pointer whitespace-nowrap transition-all hover:-translate-y-0.5"
        style={{ background: 'linear-gradient(135deg, #0d9488, #0891b2)', boxShadow: '0 4px 20px rgba(13,148,136,0.4)' }}
      >
        <i className="ri-feedback-line text-sm"></i>
        <span>意見回饋</span>
      </button>

      {/* Modal 遮罩 */}
      {open && (
        <div
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4"
          style={{ background: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(4px)' }}
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
        >
          <div className="w-full max-w-md bg-white rounded-3xl overflow-hidden" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>

            {/* 標題列 */}
            <div className="px-5 pt-5 pb-4 flex items-center justify-between" style={{ background: 'linear-gradient(135deg, #0d9488, #0891b2)' }}>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-xl">
                  <i className="ri-flask-line text-white text-base"></i>
                </div>
                <div>
                  <p className="text-white font-black text-sm leading-tight">測試版意見回饋</p>
                  <p className="text-white/70 text-xs">您的意見是我們進步的動力</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-base"></i>
              </button>
            </div>

            {submitted ? (
              <div className="px-6 py-10 flex flex-col items-center text-center">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-50 rounded-full mb-4">
                  <i className="ri-checkbox-circle-line text-teal-500 text-3xl"></i>
                </div>
                <p className="text-gray-900 font-black text-lg mb-1">感謝您的回饋！</p>
                <p className="text-gray-500 text-sm mb-6">我們會認真閱讀每一則建議，持續優化平台功能。</p>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="px-8 py-2.5 text-white text-sm font-bold rounded-full cursor-pointer whitespace-nowrap"
                  style={{ background: 'linear-gradient(135deg, #0d9488, #0891b2)' }}
                >
                  關閉
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="px-5 py-5 space-y-4">

                {/* 使用者身份 */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1.5">您的身份</label>
                  <div className="flex gap-2">
                    {['屋主', '租客', '訪客'].map((role) => (
                      <label key={role} className="flex-1 cursor-pointer">
                        <input type="radio" name="role" value={role} className="sr-only" defaultChecked={role === '訪客'} />
                        <span className="block text-center py-2 text-xs font-semibold border-2 rounded-xl transition-all border-gray-200 text-gray-500 hover:border-teal-300 hover:text-teal-600 has-[:checked]:border-teal-500 has-[:checked]:bg-teal-50 has-[:checked]:text-teal-700">
                          {role}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* 評分 */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1.5">整體體驗評分</label>
                  <select
                    name="rating"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-teal-400 bg-white cursor-pointer"
                  >
                    <option value="">請選擇評分</option>
                    <option value="5">⭐⭐⭐⭐⭐ 非常滿意</option>
                    <option value="4">⭐⭐⭐⭐ 滿意</option>
                    <option value="3">⭐⭐⭐ 普通</option>
                    <option value="2">⭐⭐ 不滿意</option>
                    <option value="1">⭐ 很差</option>
                  </select>
                </div>

                {/* 回饋類型 */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1.5">回饋類型</label>
                  <select
                    name="type"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-teal-400 bg-white cursor-pointer"
                  >
                    <option value="">請選擇類型</option>
                    <option value="功能建議">功能建議</option>
                    <option value="問題回報">問題回報（Bug）</option>
                    <option value="介面設計">介面設計</option>
                    <option value="其他">其他</option>
                  </select>
                </div>

                {/* 詳細說明 */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1.5">詳細說明</label>
                  <textarea
                    name="content"
                    required
                    placeholder="請描述您遇到的問題或建議..."
                    maxLength={500}
                    rows={3}
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-teal-400 resize-none"
                  />
                  <p className="text-right text-[10px] text-gray-400 mt-0.5">最多 500 字</p>
                </div>

                {/* 聯絡方式（選填） */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1.5">
                    聯絡信箱 <span className="text-gray-400 font-normal">（選填，方便我們回覆您）</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-teal-400"
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full flex items-center justify-center gap-2 py-3 text-white text-sm font-bold rounded-xl cursor-pointer whitespace-nowrap transition-opacity disabled:opacity-60"
                  style={{ background: 'linear-gradient(135deg, #0d9488, #0891b2)' }}
                >
                  {submitting ? (
                    <><i className="ri-loader-4-line animate-spin text-sm"></i>送出中...</>
                  ) : (
                    <><i className="ri-send-plane-line text-sm"></i>送出回饋</>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}